<template>
  <div class="block block-categories">        
    <div class="container">                    
      <div class="block-categories__header-2">                        
        <div class="block-categories__title">
            Popular Categories                             
          <div class="decor block-categories__title-decor decor--type--center">                                
            <div class="decor__body">                                    
              <div class="decor__start">
              </div>                                    
              <div class="decor__end">
              </div>                                    
              <div class="decor__center">
              </div>                                
            </div>                            
          </div>                        
        </div>                    
      </div>      
    </div>                
    <div class="block-categories__body">                    
      <div class="decor block-categories__body-decor decor--type--bottom">                        
        <div class="decor__body">                            
          <div class="decor__start"></div>                            
          <div class="decor__end"></div>                            
          <div class="decor__center"></div>                        
        </div>                    
      </div>                    
      <div class="container">                        
        <div class="block-categories__list">
          <popular-item 
            v-for="(category, indx) in populars"
            :key="category.ID"
            :index="indx"
            :categoryDetails='category'
          ></popular-item>                  
        </div>                    
      </div>                
    </div>          
  </div>      
</template>



<script>
import PopularItem from './PopularItem.vue';
import axiosvl from "../../../axios/axios-vl.js";

export default {
  components : {
    PopularItem
  },


  data() {
    return {
      populars: [],
    };
  },

  methods: {
    fetchPopulars() {
      const popular_categs_uri = this.$store.getters['api/popular_categs_uri'];
      axiosvl.post(popular_categs_uri, {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {"value": this.$store.getters.customer},
                  }
              }
          }
      )
      .then((response) => {
          // const fields = response.data.webroutine.fields;
          const POPCATS = response.data.webroutine.lists.POPCATS.entries;

          POPCATS.forEach((cat,i) => {

            if(cat.DMCD02 == ''){
              this.populars.push({
                ID : i,
                level : 1,
                name: cat.CATNAME,
                category_code: cat.DMCD01,
                DMCD01: cat.DMCD01,
                DMCD02: cat.DMCD02,
                category_url: '/category/1/' + cat.DMCD01
              });
            }else{
              this.populars.push({
                ID : i,
                level : 2,
                name: cat.CATNAME,
                category_code: cat.DMCD02,
                DMCD01: cat.DMCD01,
                DMCD02: cat.DMCD02,
                category_url: '/category/2/' + cat.DMCD01 + '/' + cat.DMCD02
              });
            }

              const features = [];
              const subcat = POPCATS.filter(c => c.DMCD01 == cat.DMCD01 && c.DMCD02 != '');

              subcat.forEach(sc => {
                features.push({
                  url         : '/category/2/' + sc.DMCD01 + '/' + sc.DMCD02 + '/',
                  description : sc.CATNAME
                });
              });

              this.populars[i].features = features;
            
          });

      });
    }
  },

  created() {
    this.fetchPopulars();
    // this.populars = [
    //   {
    //     ID          : 1,
    //     name        : 'Headlights',
    //     image       : 'images/categories/category-1-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Headlights'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Tail Lights'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Fog Lights'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Turn Signals'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Switches and Relays'
    //       },
    //     ]
    //   },
    //   {
    //     ID          : 2,
    //     name        : 'Fuel System',
    //     image       : 'images/categories/category-2-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Fuel Pumps'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Motor Oil'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Spark Plugs'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Fuel Injector'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Control Motor'
    //       },
    //     ]
    //   },
    //   {
    //     ID          : 3,
    //     name        : 'Body Parts',
    //     image       : 'images/categories/category-3-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Bumpers'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Hoods'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Grilles'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Fog Lights'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Door Handles'
    //       },
    //     ]
    //   },
    //   {
    //     ID          : 4,
    //     name        : 'Interior Parts',
    //     image       : 'images/categories/category-4-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Dashboards'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Seat Covers'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Floor Mats'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Sun Shades'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Visors'
    //       },
    //     ]
    //   },
    //   {
    //     ID          : 5,
    //     name        : 'Wheels & Tires',
    //     image       : 'images/categories/category-5-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Wheel Covers'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Brake Kits'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Tire Chains'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Wheel disks'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Tires'
    //       },
    //     ]
    //   },
    //   {
    //     ID          : 6,
    //     name        : 'Engine & Drivetrain',
    //     image       : 'images/categories/category-6-160x160.jpg',
    //     category_url : '/',
    //     features : [
    //       {
    //         url         : '/',
    //         description : 'Air Filters'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Oxygen Sensors'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Heating'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Exhaust'
    //       },
    //       {
    //         url         : '/',
    //         description : 'Cranks & Pistons'
    //       },
    //     ]
    //   },
      
    // ];
  }

}
</script>